import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { SettingsContext } from "../../SettingsContext";
import MultiplierComponent from "./components/MultiplierComponent";
import FreeItemSelectorComponent from "./components/FreeItemSelectorComponent";
import DiscountPercentageComponent from "./components/DiscountPercentageComponent";
import BundleItemsComponent from "./components/BundleItemsComponent";
import {
    StyledSelect,
    StyledLabel,
    FormGroup
} from '../../../shared/layout/forms/FormElements';

import ItemCard from '../../../shared/layout/cards/ItemCard';

const IncentiveComponent = ({ incentive, index, onDelete }) => {
    const { siteSettings } = useContext(SettingsContext);
    const incentiveTypes = siteSettings?.getIncentiveTypes() || [];
    const [, forceUpdate] = useState(0);

    const selectedType = incentive.typeId
        ? incentiveTypes.find(type => type.id === incentive.typeId)
        : null;

    const selectedAttribute = selectedType?.attributes.find(attr => attr.id === incentive.attributeId);

    const handleTypeChange = (event) => {
        const newTypeId = event.target.value;
        incentive.typeId = newTypeId;
        incentive.attributeId = '';
        incentive.value = '';
        incentive.operator = '';
        forceUpdate(prev => prev + 1);
    };

    const handleAttributeChange = (event) => {
        const newAttributeId = event.target.value;
        incentive.attributeId = newAttributeId;
        incentive.value = '';
        incentive.operator = '';
        forceUpdate(prev => prev + 1);
    };

    const handleValueChange = (field, value) => {
        incentive[field] = value;
        forceUpdate(prev => prev + 1);
    };

    const title = `Incentive ${index + 1}: ${selectedType?.name || 'New'} - ${selectedAttribute?.name || ''}`;

    return (
        <ItemCard title={title} onDelete={onDelete}>
            <FormGroup>
                <StyledLabel htmlFor="incentiveType">Incentive Type</StyledLabel>
                <StyledSelect
                    id="incentiveType"
                    value={incentive.typeId || ''}
                    onChange={handleTypeChange}
                >
                    <option value="">Select Incentive Type</option>
                    {incentiveTypes.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.name}
                        </option>
                    ))}
                </StyledSelect>
            </FormGroup>

            {selectedType && (
                <FormGroup>
                    <StyledLabel htmlFor="incentiveAttribute">Incentive Attribute</StyledLabel>
                    <StyledSelect
                        id="incentiveAttribute"
                        value={incentive.attributeId || ''}
                        onChange={handleAttributeChange}
                    >
                        <option value="">Select Attribute</option>
                        {selectedType.attributes.map(attr => (
                            <option key={attr.id} value={attr.id}>
                                {attr.name}
                            </option>
                        ))}
                    </StyledSelect>
                </FormGroup>
            )}

            {selectedType && selectedAttribute && (
                <div style={{ marginTop: '12px' }}>
                    {(() => {
                        switch (selectedAttribute.key) {
                            case 'multiplier':
                                return (
                                    <MultiplierComponent
                                        value={incentive.value}
                                        operator={incentive.operator}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'free_item_id':
                                return (
                                    <FreeItemSelectorComponent
                                        value={incentive.value}
                                        operator={incentive.operator}
                                        target="incentives"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'discount_percentage':
                                return (
                                    <DiscountPercentageComponent
                                        value={incentive.value}
                                        operator={incentive.operator}
                                        onChange={handleValueChange}
                                    />
                                );
                            case 'bundle_items':
                                return (
                                    <BundleItemsComponent
                                        value={incentive.value}
                                        operator={incentive.operator}
                                        target="incentives"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                        onChange={handleValueChange}
                                    />
                                );
                            default:
                                return null;
                        }
                    })()}
                </div>
            )}
        </ItemCard>
    );
};

export default IncentiveComponent;
